import { PROFILE_CARD_CLASS_NAME } from "../profileCards.constants";
import type { ProfileSectionCardProps } from "../profileCards.types";

export function ProfileSectionCard({
  title,
  action,
  children,
}: ProfileSectionCardProps) {
  return (
    <section aria-label={title} className={PROFILE_CARD_CLASS_NAME}>
      <div className="mb-4 flex items-center justify-between gap-3">
        <h2 className="text-base font-bold text-[#101828]">{title}</h2>
        {action}
      </div>
      {children}
    </section>
  );
}
